import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import systemDrawer from './system_drawer.vue';
export default {
  name: 'five-in-one',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    systemDrawer: systemDrawer
  },
  computed: {
    icons: function icons() {
      var value = this.value.config.value.concat([this.value.config.switch_account]);
      return value.filter(function (i) {
        return i.flag;
      });
    },
    Styles: function Styles() {
      var _this$value$config = this.value.config,
        _this$value$config$po = _this$value$config.position,
        position = _this$value$config$po === void 0 ? {} : _this$value$config$po,
        _this$value$config$se = _this$value$config.search,
        search = _this$value$config$se === void 0 ? {} : _this$value$config$se;
      var _position$icon_size = position.icon_size,
        icon_size = _position$icon_size === void 0 ? 40 : _position$icon_size,
        _position$icon_color = position.icon_color,
        icon_color = _position$icon_color === void 0 ? '#c20c0c' : _position$icon_color,
        _position$font_size = position.font_size,
        font_size = _position$font_size === void 0 ? 28 : _position$font_size,
        _position$font_color = position.font_color,
        font_color = _position$font_color === void 0 ? '#c20c0c' : _position$font_color,
        _position$in_icon_siz = position.in_icon_size,
        in_icon_size = _position$in_icon_siz === void 0 ? 20 : _position$in_icon_siz,
        _position$in_icon_col = position.in_icon_color,
        in_icon_color = _position$in_icon_col === void 0 ? '#c20c0c' : _position$in_icon_col,
        _position$bg_color = position.bg_color,
        position_bg_color = _position$bg_color === void 0 ? '#ffffff' : _position$bg_color,
        _position$opacity = position.opacity,
        position_opacity = _position$opacity === void 0 ? 30 : _position$opacity;
      var _this$value$config2 = this.value.config,
        _this$value$config2$b = _this$value$config2.bg_color,
        bg_color = _this$value$config2$b === void 0 ? '#ffffff' : _this$value$config2$b,
        _this$value$config2$s = _this$value$config2.split_color,
        split_color = _this$value$config2$s === void 0 ? '#d8d8d8' : _this$value$config2$s;
      var search_bg_color = search.bg_color,
        opacity = search.opacity;
      var baseSize = 32; //基准值 16*2 C端即可直接取值

      var iconFontSize = icon_size / baseSize;
      var fontSize = font_size / baseSize;
      var enterIconFontSize = in_icon_size / baseSize;
      return {
        '--iconFontSize': iconFontSize + 'rem',
        '--iconColor': icon_color || '#c20c0c',
        '--fontSize': fontSize + 'rem',
        '--color': font_color || '#c20c0c',
        '--enterIconFontSize': enterIconFontSize + 'rem',
        '--enterIconColor': in_icon_color || '#c20c0c',
        '--posBgColor': position_bg_color,
        '--posOpacity': position_opacity / 100,
        '--bgColor': bg_color,
        '--splitColor': split_color,
        '--searchBgColor': search_bg_color,
        '--opacity': opacity / 100
      };
    }
  }
};